module.exports = __webpack_public_path__ + "img/img36_3.924318de.svg";